import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import { GET_SURGE_TEMPLATE_VERSION, GET_SURGE_TEMPLATE_VERSION_SUCCESS, GET_SURGE_TEMPLATE_VERSION_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';

function* getSurgeTemplateVersion({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { entity_type } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/surge-templates/${entity_type}/versions`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_SURGE_TEMPLATE_VERSION_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_SURGE_TEMPLATE_VERSION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_SURGE_TEMPLATE_VERSION_ERROR, payload: error });
  }
}

export function* watchgetSurgeTemplateVersion() {
  yield takeEvery(GET_SURGE_TEMPLATE_VERSION, getSurgeTemplateVersion);
}

function* getSurgeTemplateVersionSaga() {
  yield all([fork(watchgetSurgeTemplateVersion)]);
}

export default getSurgeTemplateVersionSaga;
